import Vue3DraggableResizable from 'vue3-draggable-resizable';
import BookPlayer, { Props as BookPlayerProps } from './BookPlayer.vue';
import TestBookPlayer from './TestBookPlayer.vue';
import PositionPicker, { type BookPosition } from './components/PositionPicker.vue';
import directives from './directives';
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css';
import language from './language';
import { describePosition, loadEpubNavigation } from './util/epub-navigation';

export default {
  install: (app: any, _options?: any) => {
    app.component('BookPlayer', BookPlayer);
    app.use(Vue3DraggableResizable);
    app.use(directives);
  },
};
export { BookPlayer, TestBookPlayer, PositionPicker, language, describePosition, loadEpubNavigation };
export type { BookPlayerProps, BookPosition };
export * from './types';
